import { Entypo } from "@expo/vector-icons";
import { Icon } from "native-base";

export const IconChevronDown = ({ size = 32, solid, ...props }) => {
  const iconName = "chevron-small-down";
  return <Icon as={Entypo} name={iconName} {...{ size }} {...props} />;
};
